export default "__VITE_ASSET__CMZUhpbI__"